import CssBaseline from '@mui/material/CssBaseline';
import Hero from './components/Hero';
import Highlights from './components/Highlights';
import Features from './components/Features';
import Footer from './components/Footer';
import AppTheme from '../shared-theme/AppTheme';

export default function MarketingPage(props) {
    return (
        <AppTheme {...props}>
            <CssBaseline enableColorScheme />
            <Hero />
            <>
                <Features />
                <Highlights />
                <Footer />
            </>
        </AppTheme>
    );
}
